import { IAirDatepickerInstance, IResetSelectedDateParams } from '@/interfaces';
import { MutableRefObject } from 'react';

export function resetSelectedDate({
  date,
  instanceRef,
  placeholderFormat,
}: IResetSelectedDateParams) {
  if (!instanceRef) return;
  const instance = instanceRef as MutableRefObject<IAirDatepickerInstance>;
  const fieldWasNotEdited = date === placeholderFormat;

  if (fieldWasNotEdited || date === '') {
    instance?.current?.unselectDate(instance?.current?.lastSelectedDate);
    instance?.current?.setViewDate(new Date());
  }
}
